import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="pursuitsAccount";

export function listAllByPursuitsId(PursuitsId) {
  console.log("parameter:", PursuitsId)
  return axios({
    url: `/ws/${moduleName}/listAllByPursuitsId/${PursuitsId}`,
    method: 'get',
  })
}

export function updateByPursuitsId(parameter) {
  console.log("parameter:", parameter)
  return axios({
    url: `/ws/${moduleName}/updateByPursuitsId`,
    method: 'post',
    data: parameter
  })
}

export default {
  listAllByPursuitsId,
  updateByPursuitsId
}